import { render, staticRenderFns } from "./POPrintTemplate.vue?vue&type=template&id=2a703ddf&scoped=true"
import script from "./POPrintTemplate.vue?vue&type=script&lang=js"
export * from "./POPrintTemplate.vue?vue&type=script&lang=js"
import style0 from "./POPrintTemplate.vue?vue&type=style&index=0&id=2a703ddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a703ddf",
  null
  
)

export default component.exports